import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Modal, Button, Switch, Space, Radio, Slider } from "antd";
import ControllerPicture from "../../components/picture/controller";

export default function Erv(props) {
  const [data, setData] = useState({
    id: 1,
    house_number: "181/1",
    room_name: "Living Room",
    mac: "0038004442435708",
    device_id: "erv",
    device_name: "ERV Living",
    device_model: "vent",
    device_type: "erv",
    device_status: "off",
    device_mode: "heat",
    device_fanspeed: "high",
    device_temp: null,
    device_sweep: null,
    device_group: null,
    device_gang: null,
  });

  const [valueMode, setValueMode] = useState("");

  useEffect(() => {
    if (props.data) {
      setData(props.data);
      setValueMode(props.data["device_mode"]);
    }
    return () => {
      // setData({})
    };
  }, [props.data]);

  useEffect(() => {
    props.getData(data);
    return () => {};
  }, [data]);

  const modes = [
    {
      key: 1,
      value: "supply",
      name: "Supply",
    },
    {
      key: 2,
      value: "vent",
      name: "Vent",
    },
    {
      key: 3,
      value: "heat",
      name: "Heat",
    },
  ];

  // const marks = {
  //   0: (
  //     <>
  //       <div style={styles.textModeFan}>Low</div>
  //     </>
  //   ),
  //   50: (
  //     <>
  //       <div style={styles.textModeFan}>Mid</div>
  //     </>
  //   ),
  //   100: (
  //     <>
  //       <div style={styles.textModeFan}>High</div>
  //     </>
  //   ),
  // };

  const marksBtnFan = [
    {
      value: 0,
      nameBtn: "Low",
    },
    {
      value: 50,
      nameBtn: "Mid",
    },
    {
      value: 100,
      nameBtn: "High",
    },
  ];

  const fanspeed = (value) => {
    if (value === "low") {
      return 0;
    } else if (value === "medium") {
      return 50;
    } else if (value === "high") {
      return 100;
    } else {
      return 0;
    }
  };

  const controllerSpeed = (value) => {
    let speed = "low";
    if (value === 0) {
      speed = "low";
    } else if (value === 50) {
      speed = "medium";
    } else if (value === 100) {
      speed = "high";
    } else {
      speed = "low";
    }
    setData({ ...data, device_fanspeed: speed });
  };

  const controllerMode = (value) => {
    var data_value = value.target.value;
    setData({ ...data, device_mode: data_value.toLowerCase() });
    setValueMode(data_value);
  };

  return (
    <div>
      {data.select_schedule === "true" ? (
        <div style={styles.cardChoose}>
          <Row>
            <Col span={20}>
              <Row>
                <Col span={3} style={{ width: "200px" }}>
                  <div
                    onClick={() => {
                      setData({ ...data, select_schedule: "false", device_status: "off" });
                    }}
                  >
                    {ControllerPicture.erv()}
                  </div>
                </Col>
                <Col span={21}>
                  <div
                    style={styles.textDevice}
                    onClick={() => {
                      setData({ ...data, select_schedule: "false", device_status: "off" });
                    }}
                  >
                    Energy Recovery Ventilation
                  </div>
                </Col>
              </Row>
            </Col>
            <Col span={4} style={{ textAlign: "end", paddingTop: "3px" }}>
              <Space direction="vertical">
                <Switch
                  onChange={(e) => {
                    let status = "off";
                    if (e) {
                      status = "on";
                    }
                    setData({ ...data, device_status: status });
                  }}
                  checked={data["device_status"] === "on" ? true : false}
                  checkedChildren="ON"
                  unCheckedChildren="OFF"
                />
              </Space>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={4} style={styles.textMode}>
              Mode:
            </Col>
            <Col span={20}>
              <Radio.Group onChange={controllerMode} value={valueMode}>
                <Row>
                  {modes.map((e) => {
                    return (
                      <Col span={8}>
                        <div>
                          <Radio value={e.value} disabled={data["device_status"] === "off" ? true : false}>
                            <div
                              style={
                                valueMode === e.value
                                  ? styles.fontNumber_choose
                                  : styles.fontNumber
                              }
                            >
                              {e.name === "Heat" ? (
                                <>{ControllerPicture.heat()}</>
                              ) : null}
                              {e.name === "Vent" ? (
                                <>{ControllerPicture.vent()}</>
                              ) : null}
                              {e.name === "Supply" ? (
                                <>{ControllerPicture.supply()}</>
                              ) : null}
                            </div>
                          </Radio>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </Radio.Group>
            </Col>
          </Row>
          {/* Start Mode Fan */}
          <Row>
            <Col span={5}>
              <Row>
                <Col span={12} style={{ width: "200px" }}>
                  {ControllerPicture.wind()}
                </Col>
                <Col span={12}>
                  <div style={styles.fontInpage}>Fan</div>
                </Col>
              </Row>
            </Col>
          </Row>
          <div style={styles.cardInerv}>
            <div>
              <Row gutter={[16, 8]} justify="center" align="middle">
                {marksBtnFan.map((item) => (
                  <Col key={item.value} span={4}>
                    <div
                      style={
                        item.value === fanspeed(data["device_fanspeed"])
                          ? styles.btnFanChoose
                          : styles.btnFan
                      }
                      onClick={() => controllerSpeed(item.value)}
                    >
                      {item.nameBtn}
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
          {/* End Mode Fan */}
          {/* <div style={styles.cardInerv}>
            <Row gutter={[8, 8]}>
              <Col span={7}>
                <div>
                  <Row>
                    <Col span={12} style={{ width: "250px" }}>
                      {ControllerPicture.wind()}
                    </Col>
                    <Col span={12}>
                      <div style={styles.fontInpage}>Fan</div>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={17}>
                <div>
                  <Slider
                    disabled={data["device_status"] === "off" ? true : false}
                    marks={marks}
                    value={fanspeed(data["device_fanspeed"])}
                    step={50}
                    onChange={controllerSpeed}
                    tooltip={{
                      formatter: null,
                    }}
                  />
                </div>
              </Col>
            </Row>
          </div> */}
        </div>
      ) : null}
      {data.select_schedule === "false" ? (
        <div style={styles.card}>
          <Row>
            <Col span={20}>
              <Row>
                <Col span={3} style={{ width: "200px" }}>
                  <div
                    onClick={() => {
                      setData({ ...data, select_schedule: "true", device_status: "on" });
                    }}
                  >
                    {ControllerPicture.ervOff()}
                  </div>
                </Col>
                <Col span={21}>
                  <div
                    style={styles.textDeviceOff}
                    onClick={() => {
                      setData({ ...data, select_schedule: "true", device_status: "on" });
                    }}
                  >
                    Energy Recovery Ventilation
                  </div>
                </Col>
              </Row>
            </Col>
            <Col span={4} style={{ textAlign: "end", paddingTop: "3px" }}>
              <Space direction="vertical">
                <Switch
                  checked={data["device_status"] === "on" ? true : false}
                  checkedChildren="ON"
                  unCheckedChildren="OFF"
                />
              </Space>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={4} style={styles.textMode}>
              Mode:
            </Col>
            <Col span={20}>
              <Radio.Group value={valueMode} disabled>
                <Row>
                  {modes.map((e) => {
                    return (
                      <Col span={8}>
                        <div>
                          <Radio value={e.value}>
                            <div>
                              {e.name === "Heat" ? (
                                <>{ControllerPicture.heat()}</>
                              ) : null}
                              {e.name === "Vent" ? (
                                <>{ControllerPicture.vent()}</>
                              ) : null}
                              {e.name === "Supply" ? (
                                <>{ControllerPicture.supply()}</>
                              ) : null}
                            </div>
                          </Radio>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </Radio.Group>
            </Col>
          </Row>
          {/* Start Mode Fan */}
          <Row>
            <Col span={5}>
              <Row>
                <Col span={12} style={{ width: "200px" }}>
                  {ControllerPicture.wind()}
                </Col>
                <Col span={12}>
                  <div style={styles.fontInpage}>Fan</div>
                </Col>
              </Row>
            </Col>
          </Row>
          <div style={styles.cardInervoff}>
            <div>
              <Row gutter={[16, 8]} justify="center" align="middle">
                {marksBtnFan.map((item) => (
                  <Col key={item.value} span={4}>
                    <div
                      style={
                        item.value === fanspeed(data["device_fanspeed"])
                          ? styles.btnFanChooseOff
                          : styles.btnFanOff
                      }
                    >
                      {item.nameBtn}
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
          {/* End Mode Fan */}
          {/* <div style={styles.cardInervoff}>
            <Row gutter={[8, 8]}>
              <Col span={7}>
                <div>
                  <Row>
                    <Col span={12} style={{ width: "250px" }}>
                      {ControllerPicture.wind()}
                    </Col>
                    <Col span={12}>
                      <div style={styles.fontInpageOff}>Fan</div>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={17}>
                <div>
                  <Slider
                  disabled
                  value={fanspeed(data["device_fanspeed"])}
                    marks={marks}
                    step={50}
                    tooltip={{
                      formatter: null,
                    }}
                  />
                </div>
              </Col>
            </Row>
          </div> */}
        </div>
      ) : null}
    </div>
  );
}

const styles = {
  head: {
    backgroundColor: "#F0F9FB",
    height: "108px",
  },
  card: {
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    // alignItems: "flex-start",
    gap: "12px",
    borderRadius: "16px",
    border: "1px solid #E3E3E3",
  },
  cardChoose: {
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    gap: "12px",
    borderRadius: "16px",
    border: "1px solid #B5EAEF",
    background: "#EBF4FA",
  },
  cardInerv: {
    flexShrink: "0",
    borderRadius: "16px",
    border: "1px solid #B5EAEF",
    background: "#FBFBFB",
    padding: "10px 15px 10px 8px",
  },
  fontInpage: {
    color: "#56585D",
    paddingTop: "2px",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  fontNumber_choose: {
    color: "#56585D",
    textAlign: "center",
    fontFamily: "Gotham",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  fontNumber: {
    color: "#919499",
    textAlign: "center",
    fontFamily: "Gotham",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  textMode: {
    color: "#56585D",
    // textAlign: "center",
    fontFamily: "Gotham",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "21px",
  },
  textModeFan: {
    color: "#56585D",
    // textAlign: "center",
    marginTop: "10px",
    fontFamily: "Gotham",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "21px",
  },

  textDevice: {
    color: "#3EA8B8",
    paddingTop: "5px",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  textDeviceOff: {
    color: "#56585D",
    paddingTop: "5px",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  fontInpageOff: {
    color: "#56585D",
    paddingTop: "5px",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px" /* 150% */,
  },
  cardInervoff: {
    flexShrink: "0",
    borderRadius: "16px",
    border: "1px solid #E3E3E3",
    background: "#FFF",
    padding: "10px 15px 10px 8px",
  },

  btnFan: {
    display: "flex",
    width: "30px" /* ปรับให้ปุ่มใหญ่ขึ้น */,
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #B5EAEF",
    background: "#FBFBFB",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    margin: "auto" /* จัดปุ่มให้อยู่กึ่งกลาง Col */,
    cursor: "pointer" /* ทำให้เป็น Cursor แบบคลิกได้ */,
  },
  btnFanChoose: {
    display: "flex",
    width: "30px",
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #B5EAEF",
    background: "rgba(235, 244, 250, 1)",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    fontWeight: "bold",
    margin: "auto",
    cursor: "pointer",
  },
  btnFanOff: {
    display: "flex",
    width: "30px",
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#FBFBFB",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    margin: "auto",
    cursor: "pointer",
  },
  btnFanChooseOff: {
    display: "flex",
    width: "30px",
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#E3E3E3",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    fontWeight: "bold",
    margin: "auto",
    cursor: "pointer",
  },
};
